import { chunk, map } from "lodash";
import Infinite from "components/product/infinite/Infinite";

import {
    GridVariant1,
    GridVariant2,
    GridVariant3,
    GridVariant4
} from 'components/product/grid/GridVariant';

import styles from "components/product/grid/ProductGrid.module.scss";

const ProductGrid = ({
  products,
  pagination
}) => {
    let variantType = 0;

    var gridProducts = [];
    products.forEach(function(product, index){
        gridProducts.push(product);
        if(index == 15){
            gridProducts.push({
                cardType : "social-card",
                id: "facebook",
                title: "Facebook",
                image: "https://instance11.admin.grandus.sk/files/attachment/2020-08/76/7741ac/facebook-bg.jpg",
                icon: '<svg width="55" height="119" viewBox="0 0 55 119" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4717 119H36.4588V58.9812H53.2124L55 38.8919H36.5004C36.5004 38.8919 36.5004 31.3791 36.5004 27.436C36.5004 22.7042 37.4565 20.8364 42.0295 20.8364C45.7294 20.8364 55 20.8364 55 20.8364V0C55 0 41.3228 0 38.3711 0C20.5367 0 12.4717 7.84479 12.4717 22.8702C12.4717 35.9449 12.4717 38.8919 12.4717 38.8919H0V59.2302H12.4717V119Z" fill="white"/></svg>',
                link: "https://www.facebook.com/RegionTrnava/"
            });
        }
        if(index == 17){
            gridProducts.push({
                cardType : "social-card",
                id: "instagram",
                title: "Instagram",
                image: "https://instance11.admin.grandus.sk/files/attachment/2020-08/73/ce0ed2/instagram-bg.jpg",
                icon: '<svg width="94" height="94" viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.92 8.44559C59.444 8.44559 60.9238 8.48168 65.8684 8.73433C70.4521 8.95088 72.9425 9.70882 74.5666 10.3585C76.7683 11.2247 78.3202 12.2353 79.9444 13.8594C81.6046 15.5197 82.6152 17.0716 83.4453 19.2372C84.095 20.8974 84.8529 23.3878 85.0695 27.9354C85.286 32.8801 85.3582 34.3598 85.3582 46.8839C85.3582 59.4079 85.3221 60.8877 85.0695 65.8323C84.8529 70.416 84.095 72.9064 83.4453 74.5305C82.5791 76.7322 81.5685 78.2841 79.9444 79.9444C78.3202 81.5685 76.7322 82.6152 74.5666 83.4453C72.9064 84.095 70.416 84.8529 65.8684 85.0695C60.9238 85.286 59.444 85.3582 46.92 85.3582C34.3959 85.3582 32.9162 85.3221 27.9715 85.0695C23.3878 84.8529 20.8974 84.095 19.2733 83.4453C17.0716 82.5791 15.5197 81.5685 13.8594 79.9444C12.2353 78.2841 11.1886 76.7322 10.3585 74.5305C9.70882 72.8703 8.95088 70.3799 8.73433 65.8323C8.51778 60.9599 8.44559 59.444 8.44559 46.92C8.44559 34.3959 8.48168 32.9162 8.73433 27.9715C8.95088 23.3878 9.70882 20.8974 10.3585 19.2733C11.1886 17.0716 12.1992 15.4836 13.8594 13.8594C15.5197 12.1992 17.0716 11.1886 19.2733 10.3585C20.9335 9.70882 23.4239 8.95088 27.9715 8.73433C32.9162 8.51778 34.3959 8.44559 46.92 8.44559ZM46.92 0C34.1794 0 32.5913 0.0721845 27.5745 0.288738C22.5938 0.505292 19.165 1.29932 16.1693 2.45427C13.0654 3.64532 10.4668 5.26947 7.86812 7.86812C5.26947 10.4668 3.64532 13.1015 2.45427 16.1693C1.29932 19.165 0.505292 22.5577 0.288738 27.5745C0.0360923 32.5913 0 34.1794 0 46.92C0 59.6605 0.0360923 61.2486 0.288738 66.2654C0.505292 71.2462 1.29932 74.6749 2.45427 77.6706C3.64532 80.7384 5.26947 83.3732 7.86812 85.9718C10.4668 88.5704 13.1015 90.1946 16.1693 91.3856C19.165 92.5406 22.5577 93.3346 27.5745 93.5512C32.5913 93.8038 34.1794 93.8399 46.92 93.8399C59.6605 93.8399 61.2486 93.8038 66.2654 93.5512C71.2462 93.3346 74.6749 92.5406 77.6706 91.3856C80.7745 90.1946 83.3732 88.5704 85.9718 85.9718C88.5704 83.3732 90.1946 80.7384 91.3856 77.6706C92.5406 74.6749 93.3346 71.2822 93.5512 66.2654C93.8038 61.2847 93.8399 59.6605 93.8399 46.92C93.8399 34.1794 93.8038 32.5913 93.5512 27.5745C93.3346 22.5938 92.5406 19.165 91.3856 16.1693C90.1946 13.1015 88.5704 10.4668 85.9718 7.86812C83.3732 5.26947 80.7384 3.64532 77.6706 2.45427C74.6749 1.29932 71.2822 0.505292 66.2654 0.288738C61.2847 0.0721845 59.6605 0 46.92 0Z" fill="white"/><path d="M46.9202 22.8467C33.6021 22.8467 22.8105 33.6383 22.8105 46.9563C22.8105 60.2744 33.6021 71.0659 46.9202 71.0659C60.2382 71.0659 71.0298 60.2744 71.0298 46.9563C71.0298 33.6383 60.2382 22.8467 46.9202 22.8467ZM46.9202 62.5843C38.2941 62.5843 31.2922 55.5824 31.2922 46.9563C31.2922 38.3303 38.2941 31.3284 46.9202 31.3284C55.5462 31.3284 62.5481 38.3303 62.5481 46.9563C62.5842 55.5824 55.5823 62.5843 46.9202 62.5843Z" fill="white"/><path d="M77.6006 21.8716C77.6006 24.9755 75.0742 27.502 71.9702 27.502C68.8663 27.502 66.3398 24.9755 66.3398 21.8716C66.3398 18.7677 68.8663 16.2412 71.9702 16.2412C75.0742 16.2412 77.6006 18.7677 77.6006 21.8716Z" fill="white"/></svg>',
                link: "https://www.instagram.com/regiontrnava/"
            });
        }
    });
    
    return (
      <>
        <div className={styles.grid} id="products-list">
            {
                map(chunk(gridProducts, 3), (productsChunk, index) => {
                    variantType += 1;
                    if(variantType > 4){
                        variantType = 1;
                    }
                    return (
                        <div key={`grid-products-chunk-${index}`} className={styles.gridItem}>
                            {
                                (variantType == 1)? (<GridVariant1 products={productsChunk} />) :
                                (variantType == 2)? (<GridVariant2 products={productsChunk} />) :
                                (variantType == 3)? (<GridVariant3 products={productsChunk} />) :
                                (<GridVariant4 products={productsChunk} />)
                            }
                        </div>
                    );
                })
            }
        </div>
        {pagination?.pageCount > 1 &&
            pagination?.currentPage !== pagination?.pageCount ? (
              <Infinite
                {...pagination}
                productClassName={styles.itemWrap + " col-md-4 col-6"}
                destinationElementId={"products-list"}
                product
                stylesGrid={styles}
              />
            ) : (
              ""
        )}

      </>
    );
};

export default ProductGrid;
